import { NEW_COST_THRESHOLDS } from '../globalConfig/constants'
import _ from 'lodash'

export const processList = (textInput, regexPattern) => {
  let splitArray = []
  const processedList = {
    recognizedValues: [],
    unrecognizedValues: [],
  }

  splitArray = textInput.trim().split(/[ ,\t]+/)

  for (let i in splitArray) {
    if (regexPattern.test(splitArray[i])) {
      processedList.recognizedValues.push(splitArray[i])
    } else if (splitArray[i] !== '') {
      processedList.unrecognizedValues.push(splitArray[i])
    }
  }

  return processedList
}

export const isAValidCostChange = (tableRow) => {
  return (
    (tableRow?.new_start_date?.cellValue ||
      tableRow?.new_start_date?.cellValue === 0) &&
    tableRow?.new_unit_cost?.cellValue &&
    tableRow?.new_unit_cost?.cellValue >= 0
  )
}

export const newCostExceedsCostRangeThresholds = (
  oldCostRange,
  newUnitCost,
) => {
  if (
    newUnitCost &&
    _.isEmpty(oldCostRange) &&
    newUnitCost >= NEW_COST_THRESHOLDS.maxDollarChange
  ) {
    return true
  } else if (
    !newUnitCost ||
    !oldCostRange ||
    !oldCostRange?.minCost ||
    !oldCostRange?.maxCost
  ) {
    return false
  } else if (
    Math.abs(
      ((newUnitCost - oldCostRange.minCost) / Math.abs(oldCostRange.minCost)) *
        100,
    ) >= NEW_COST_THRESHOLDS.maxDollarPercentageChange
  ) {
    return true
  } else if (
    Math.abs(
      ((newUnitCost - oldCostRange.maxCost) / Math.abs(oldCostRange.maxCost)) *
        100,
    ) >= NEW_COST_THRESHOLDS.maxDollarPercentageChange
  ) {
    return true
  } else {
    return false
  }
}

export const newCostExceedsCostThresholds = (oldCost, newUnitCost) => {
  if (!newUnitCost) {
    return false
  } else if (
    Math.abs(((newUnitCost - oldCost) / Math.abs(oldCost)) * 100) >=
    NEW_COST_THRESHOLDS.maxDollarPercentageChange
  ) {
    return true
  } else {
    return false
  }
}

export const containsSpecialChars = (inputString) => {
  let acceptedChars = /^[a-z0-9!@#$%^&*()-_=+{};:"',<.>/? ]+$/i
  if (inputString) {
    return !acceptedChars.test(inputString)
  } else {
    return false
  }
}

export const getOneDayInTheFuture = (date) => {
  const givenDate = new Date(date)
  let tomorrow = givenDate
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow
}
